import {
	includedPropList,
	includedT2PropList,
} from "../../../pages/activityBuilder/modules/setAside/setAside";
import type {
	ModuleFull,
	SetAsideResponse,
} from "../../../pages/activityBuilder/modules/setAside/setAsideTypes";
import { FEModules } from "../../../utils/moduleList";
import { FEModulesObj } from "../../../utils/moduleList";
import { apiSlice, publicApiSlice, TagTypes } from "../../apiSlice";
import { createModuleGetApi, createModuleUpdateApi } from "./factories/createModuleApi";
import { transformModuleResponse, prepareModulePayload } from "./factories/moduleApiUtils";

// Define constants for the module
const MODULE_TYPE = "SetAside";
const TAG: TagTypes = "SetAside";
const TAG_DEFAULTS: TagTypes = "SetAsideDefaults";
const ENDPOINT = FEModulesObj[FEModules.SetAside].path;

const transformResponse = (response: SetAsideResponse) => transformModuleResponse<SetAsideResponse, ModuleFull>({
	response,
	includedPropList,
	includedT2PropList
})

const setAsideApiSlice = createModuleGetApi<ModuleFull>({
	apiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformResponse,
})

const publicSetAsideApiSlice = createModuleGetApi<ModuleFull>({
	apiSlice: publicApiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformResponse,
})

const transformUpdatePayload = (data: ModuleFull, activityId: number) => prepareModulePayload({
	moduleData: data.module,
	tiertwoData: data.tiertwo,
	activityId
})

const mutationApiSlice = createModuleUpdateApi<ModuleFull, SetAsideResponse>({
	apiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformUpdatePayload,
	includesLandUseChange: true
})

export const {
	useGetSetAsideQuery,
	useGetSetAsideDefaultsQuery
} = setAsideApiSlice;

export const {
	useGetSetAsideQuery: usePublicGetSetAsideQuery,
	useGetSetAsideDefaultsQuery: usePublicGetSetAsideDefaultsQuery
} = publicSetAsideApiSlice;

export const {
	useUpdateSetAsideMutation,
} = mutationApiSlice;
